var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('car-map',{staticStyle:{"position":"absolute","height":"100%"},attrs:{"auto-update":false}})}
var staticRenderFns = []

export { render, staticRenderFns }